import React from 'react'
import { useQuery } from 'react-query'
import { getInstagramFeed } from '../../../moduls/instagram-feed'
import { InstagramPost } from '../../../services/types'

const InstagramFeed: React.FC = () => {
  const { data: instagramFeed = [], isFetched: instagramFeedFetched } = useQuery<InstagramPost[]>(
    'instagram-feed',
    getInstagramFeed
  )

  if (!instagramFeedFetched) {
    return null
  }

  return (
    <>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <h2 className="text-center text-[#0183BA] text-[25px] leading-tight">
            Z našeho Instagramu
          </h2>
        </div>
        {instagramFeed.length > 0 &&
          instagramFeed.slice(0, 8).map((post) => (
            <div className="col-span-6 lg:col-span-3" key={post.id}>
              <a
                href={post.permalink}
                target="_blank"
                className="instagram-image-container"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    post.media_type === 'VIDEO'
                      ? (post.thumbnail_url as string)
                      : post.media_url || ''
                  }
                  alt={post.caption || 'Instagram post'}
                  className="instagram-image"
                />
              </a>
            </div>
          ))}
      </div>
    </>
  )
}

export default InstagramFeed
